import SectionHeading from "@/components/base/SectionHeading";
import { recommendations } from "@/mocks/comicData";

export default function Recommendations() {
  return (
    <section id="recommend" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="热门内容"
          title="读懂这部漫画的延伸解读"
          description="从角色成长、继母温柔哲学到关系发展时间线，精选几篇主题解读，帮你更深入地理解继母与继姐漫画的情感世界。"
        />

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 md:mt-14">
          {recommendations.map((item) => (
            <article
              key={item.title}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-100"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-primary-700 backdrop-blur">
                  {item.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col gap-2 p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <span className="mt-auto inline-flex items-center gap-1 pt-3 text-sm font-semibold text-primary-600">
                  阅读解读
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}